const APPROVED = new Set(["approved", "active", "enabled", "aprovado", "ativado"]);
const PENDING = new Set(["pending", "submitted", "in_review", "received", "pendente", "flagged"]);
const REJECTED = new Set(["rejected", "failed", "rejeitado", "reprovado"]);
const PAUSED = new Set(["paused", "pausado"]);
const DISABLED = new Set(["disabled", "desativado", "flag", "locked"]);
const DELETED = new Set(["deleted", "excluido", "pending_deletion"]);
const APPEAL = new Set(["in_appeal", "appeal"]);

function normalizeStatus(status) {
  return String(status || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

export function classifyWhatsappTemplateStatus(status) {
  const s = normalizeStatus(status);
  if (!s) return { kind: "unknown", usable: true };
  if (APPROVED.has(s)) return { kind: "approved", usable: true };
  if (PENDING.has(s)) return { kind: "pending", usable: false };
  if (REJECTED.has(s)) return { kind: "rejected", usable: false };
  if (PAUSED.has(s)) return { kind: "paused", usable: false };
  if (DISABLED.has(s)) return { kind: "disabled", usable: false };
  if (DELETED.has(s)) return { kind: "deleted", usable: false };
  if (APPEAL.has(s)) return { kind: "appeal", usable: false };
  return { kind: "unknown", usable: false };
}

export function isWhatsappTemplateUsable(tpl) {
  if (!tpl) return false;
  if (tpl.usable === true) return true;
  if (tpl.usable === false) return false;
  return classifyWhatsappTemplateStatus(tpl.status).usable;
}

export function whatsappTemplateStatusKind(tpl) {
  if (!tpl) return "unknown";
  if (tpl.statusKind) return tpl.statusKind;
  return classifyWhatsappTemplateStatus(tpl.status).kind;
}

export function nextRejectedTemplateName(name) {
  const slug = String(name || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_]+/g, "_")
    .replace(/^_+|_+$/g, "");
  if (!slug) return "";
  const match = slug.match(/^(.*)_v(\d+)$/);
  if (match) return `${match[1]}_v${Number(match[2]) + 1}`;
  return `${slug}_v2`;
}

export function normalizeChannelTemplatesList(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.templates)) return payload.templates;
  if (Array.isArray(payload?.data?.templates)) return payload.data.templates;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}
